import { render, staticRenderFns } from "./EquipmentsTab.vue?vue&type=template&id=b8cf14fc&scoped=true&"
import script from "./EquipmentsTab.vue?vue&type=script&lang=js&"
export * from "./EquipmentsTab.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentsTab.vue?vue&type=style&index=0&id=b8cf14fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cf14fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8cf14fc')) {
      api.createRecord('b8cf14fc', component.options)
    } else {
      api.reload('b8cf14fc', component.options)
    }
    module.hot.accept("./EquipmentsTab.vue?vue&type=template&id=b8cf14fc&scoped=true&", function () {
      api.rerender('b8cf14fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/places/tabs/EquipmentsTab.vue"
export default component.exports